// This file is auto-generated. Do not edit!

export default [
  {
    address: "0xc3d688B66703497DAA19211EEdff47f25384cdc3",
    symbol: "cUSDCv3",
    borrowToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralTokens: [
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
        symbol: "UNI",
      },
      {
        address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
        symbol: "LINK",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
        symbol: "cbBTC",
      },
      {
        address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        symbol: "tBTC",
      },
      {
        address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        symbol: "weETH",
      },
      {
        address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
        symbol: "deUSD",
      },
      {
        address: "0x5C5b196aBE0d54485975D1Ec29617D42D9198326",
        symbol: "sdeUSD",
      },
      {
        address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
        symbol: "rsETH",
      },
      {
        address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
        symbol: "USDe",
      },
    ],
  },
  {
    address: "0xA17581A9E3356d9A858b789D68B4d866e593aE94",
    symbol: "cWETHv3",
    borrowToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralTokens: [
      {
        address: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
        symbol: "cbETH",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
        symbol: "rETH",
      },
      {
        address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
        symbol: "rsETH",
      },
      {
        address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        symbol: "weETH",
      },
      {
        address: "0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38",
        symbol: "osETH",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
        symbol: "ezETH",
      },
      {
        address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
        symbol: "cbBTC",
      },
      {
        address: "0xFAe103DC9cf190eD75350761e95403b7b8aFa6c0",
        symbol: "rswETH",
      },
      {
        address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        symbol: "tBTC",
      },
      {
        address: "0xA35b1B31Ce002FBF2058D22F30f95D405200A15b",
        symbol: "ETHx",
      },
      {
        address: "0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8",
        symbol: "tETH",
      },
      {
        address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
        symbol: "pufETH",
      },
      {
        address: "0xDcEe70654261AF21C44c093C300eD3Bb97b78192",
        symbol: "wOETH",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
  {
    address: "0x3Afdc9BCA9213A35503b077a6072F3D0d5AB0840",
    symbol: "cUSDTv3",
    borrowToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralTokens: [
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
        symbol: "UNI",
      },
      {
        address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
        symbol: "LINK",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
        symbol: "cbBTC",
      },
      {
        address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        symbol: "tBTC",
      },
      {
        address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
        symbol: "wUSDM",
      },
      {
        address: "0xA663B02CF0a4b149d2aD41910CB81e23e1c41c32",
        symbol: "sFRAX",
      },
      {
        address: "0xd5F7838F5C461fefF7FE49ea5ebaF7728bB0ADfa",
        symbol: "mETH",
      },
      {
        address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        symbol: "weETH",
      },
      {
        address: "0x5C5b196aBE0d54485975D1Ec29617D42D9198326",
        symbol: "sdeUSD",
      },
      {
        address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
        symbol: "deUSD",
      },
      {
        address: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
        symbol: "XAUt",
      },
      {
        address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
        symbol: "USDe",
      },
    ],
  },
  {
    address: "0x3D0bb1ccaB520A66e607822fC55BC921738fAFE3",
    symbol: "cWstETHv3",
    borrowToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    collateralTokens: [
      {
        address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
        symbol: "rsETH",
      },
      {
        address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
        symbol: "ezETH",
      },
      {
        address: "0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8",
        symbol: "tETH",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        symbol: "weETH",
      },
    ],
  },
  {
    address: "0x5d409e56d886231adaf00c8775665ad0f9897b56",
    symbol: "cUSDSv3",
    borrowToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralTokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
        symbol: "USDe",
      },
      {
        address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
        symbol: "cbBTC",
      },
      {
        address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        symbol: "tBTC",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
        symbol: "sUSDS",
      },
      {
        address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        symbol: "weETH",
      },
      {
        address: "0x56072C95FAA701256059aa122697B133aDEd9279",
        symbol: "SKY",
      },
      {
        address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
        symbol: "deUSD",
      },
      {
        address: "0x5C5b196aBE0d54485975D1Ec29617D42D9198326",
        symbol: "sdeUSD",
      },
    ],
  },
  {
    address: "0xe85Dc543813B8c2CFEaAc371517b925a166a9293",
    symbol: "cWBTCv3",
    borrowToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralTokens: [
      {
        address: "0x8236a87084f8B84306f72007F36F2618A5634494",
        symbol: "LBTC",
      },
      {
        address: "0xF469fBD2abcd6B9de8E169d128226C0Fc90a012e",
        symbol: "pumpBTC",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
] as const
